import { createEntityAdapter, EntityAdapter, EntityState, Update } from '@ngrx/entity';
import { Action, createAction, createReducer, props, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { IPlanGestionMobilite, PlanGestionMobilite } from '../../_models/PlanGestionMobilite';

export const name = 'planGestionMobilites';

export interface PlanGestionMobiliteState extends EntityState<IPlanGestionMobilite> {
  selectedId: number;
  isInitialized: boolean;
  loading: boolean;
}

function selectPlanGestionMobilite(a: IPlanGestionMobilite): any {
  return a.id;
}

function sortById(a: IPlanGestionMobilite, b: IPlanGestionMobilite): number {
  if (a.id < b.id) {
    return -1;
  } else if (a.id > b.id) {
    return 1;
  } else {
    return 0;
  }
}

const adapter: EntityAdapter<IPlanGestionMobilite> = createEntityAdapter<IPlanGestionMobilite>({
  selectId: selectPlanGestionMobilite,
  sortComparer: sortById,
});

const initialState: PlanGestionMobiliteState = adapter.getInitialState({
  selectedId: -1,
  isInitialized: false,
  loading: true,
});

/* ACTION */
export const loadPlanGestionMobilitesAction = createAction('[PlanGestionMobilite] Load PlanGestionMobilites');
export const loadPlanGestionMobilitesErrorAction = createAction('[PlanGestionMobilite] Load PlanGestionMobilites Error');
export const loadPlanGestionMobilitesSuccessAction = createAction(
  '[PlanGestionMobilite] Load PlanGestionMobilites Success',
  props<{ payload: IPlanGestionMobilite[] }>()
);
export const deepLoadPlanGestionMobiliteAction = createAction(
  '[PlanGestionMobilite] Deep Load PlanGestionMobilite',
  props<{ id: number }>()
);
export const deepLoadPlanGestionMobiliteActionSuccessAction = createAction(
  '[PlanGestionMobilite] Deep Load PlanGestionMobilite Success',
  props<{ payload: Update<IPlanGestionMobilite> | undefined }>()
);
export const setPgmsAction = createAction('[PlanGestionMobilite] Set PlanGestionMobilite', props<{ payload: IPlanGestionMobilite[] }>());

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadPlanGestionMobilitesSuccessAction, (state, { payload }) => {
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      loading: false,
    });
  }),
  on(loadPlanGestionMobilitesErrorAction, (state) => {
    return { ...state, loading: false };
  }),
  on(deepLoadPlanGestionMobiliteActionSuccessAction, (state, { payload }) => {
    if (payload) {
      return adapter.updateOne(payload, {
        ...state,
        selectedId: payload.id as number,
      });
    } else {
      return state;
    }
  }),
  on(setPgmsAction, (state, { payload }) => {
    return adapter.setAll(payload, state);
  })
);

export function planGestionMobiliteReducer(state: PlanGestionMobiliteState | undefined, action: Action): PlanGestionMobiliteState {
  return reducer(state, action);
}

/* SELECTOR */
const selectPlanGestionMobiliteState = createFeatureSelector<PlanGestionMobiliteState>(name);

const isInitialized = (state: PlanGestionMobiliteState) => state.isInitialized;
export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllPlanGestionMobilites = createSelector(selectPlanGestionMobiliteState, (state) => {
  return state.loading
    ? undefined
    : state.ids
        .map((id: any) => new PlanGestionMobilite(state.entities[id]))
        .sort((a, b) => {
          if (a.numero < b.numero) {
            return -1;
          } else if (a.numero > b.numero) {
            return 1;
          } else {
            return 0;
          }
        });
});
export const selectIsPlanGestionMobiliteInitialized = createSelector(selectPlanGestionMobiliteState, isInitialized);
export const selectedPlanGestionMobilite = createSelector(selectPlanGestionMobiliteState, (state) => {
  if (state.selectedId) {
    return new PlanGestionMobilite(state.entities[state.selectedId]);
  }

  return undefined;
});
